var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-wrap"},[_c('main-header'),_vm._v(" "),_c('div',{staticClass:"space-top"},[_c('Contact',{attrs:{"items":['استفسار'],"type":2}})],1),_vm._v(" "),_c('main-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }